import type React from 'react';

export function friendlyMime(mime: string): string {
  if (mime.includes('pdf')) return 'PDF';
  if (mime.includes('jpeg') || mime.includes('jpg')) return 'Imagem JPEG';
  if (mime.includes('png')) return 'Imagem PNG';
  if (mime.includes('webp')) return 'Imagem WebP';
  if (mime.includes('word')) return 'Word';
  if (mime.includes('sheet') || mime.includes('excel')) return 'Planilha';
  if (mime.includes('text')) return 'Texto';
  return mime || '—';
}

export function formatBytes(val: unknown): string {
  const n = Number(val);
  if (!Number.isFinite(n) || n < 0) return '—';
  if (n < 1024) return `${String(n)} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  return `${(n / (1024 * 1024)).toFixed(1)} MB`;
}

export function fmtDate(v: unknown): string {
  if (typeof v === 'string' && v.length >= 10) return v.substring(0, 10);
  return '—';
}

export function Th({ children }: { children: React.ReactNode }) {
  return (
    <th
      style={{
        padding: '0.625rem 0.75rem',
        textAlign: 'left',
        fontSize: '0.75rem',
        fontWeight: 600,
        color: 'var(--muted)',
        textTransform: 'uppercase',
        letterSpacing: '0.05em',
      }}
    >
      {children}
    </th>
  );
}

export function Td(props: React.HTMLAttributes<HTMLTableCellElement>) {
  return (
    <td style={{ padding: '0.625rem 0.75rem', fontSize: '0.875rem', ...props.style }}>
      {props.children}
    </td>
  );
}

export function PagBtn({
  active,
  disabled,
  onClick,
  label,
}: {
  active?: boolean;
  disabled?: boolean;
  onClick: () => void;
  label: string;
}) {
  return (
    <button
      type="button"
      disabled={disabled}
      onClick={onClick}
      style={{
        minWidth: 32,
        height: 32,
        padding: '0 0.5rem',
        border: active ? '1px solid var(--green)' : '1px solid var(--line)',
        borderRadius: 10,
        background: active ? 'var(--green)' : '#fff',
        color: active ? '#fff' : 'var(--muted)',
        fontSize: '0.8rem',
        cursor: disabled ? 'default' : 'pointer',
        opacity: disabled ? 0.4 : 1,
      }}
    >
      {label}
    </button>
  );
}

export function Skeleton() {
  return (
    <div
      style={{
        background: '#fff',
        borderRadius: 14,
        border: '1px solid var(--line)',
        padding: '1.25rem 1.5rem',
      }}
    >
      {Array.from({ length: 4 }, (_, i) => (
        <div
          key={i}
          style={{
            display: 'flex',
            gap: '2rem',
            padding: '0.5rem 0',
            borderBottom: i < 3 ? '1px solid var(--line-soft)' : 'none',
          }}
        >
          <div
            style={{ width: 200, height: 14, background: 'var(--line-soft)', borderRadius: 8 }}
          />
          <div
            style={{ width: 100, height: 14, background: 'var(--line-soft)', borderRadius: 8 }}
          />
          <div
            style={{ width: 120, height: 14, background: 'var(--line-soft)', borderRadius: 8 }}
          />
        </div>
      ))}
    </div>
  );
}

export const fieldLabel: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  gap: 4,
  fontSize: '0.8rem',
  color: 'var(--ink)',
  fontWeight: 600,
};
export const modalOverlay: React.CSSProperties = {
  position: 'fixed',
  inset: 0,
  background: 'var(--overlay)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 50,
};
export const modalStyle: React.CSSProperties = {
  background: '#fff',
  borderRadius: 12,
  padding: '1.5rem',
  width: '100%',
  maxWidth: 460,
  boxShadow: '0 8px 32px rgba(38, 49, 39, 0.08)',
};
export const inputCss: React.CSSProperties = {
  padding: '0.5rem 0.75rem',
  border: '1px solid var(--line)',
  borderRadius: 10,
  fontSize: '0.875rem',
  outline: 'none',
  width: '100%',
  boxSizing: 'border-box',
};
export const primaryBtn: React.CSSProperties = {
  background: 'var(--green)',
  color: '#fff',
  border: 'none',
  borderRadius: 999,
  padding: '0.5rem 1rem',
  fontSize: '0.85rem',
  cursor: 'pointer',
  fontWeight: 600,
};
export const secondaryBtn: React.CSSProperties = {
  background: '#fff',
  color: 'var(--muted)',
  border: '1px solid var(--line)',
  borderRadius: 999,
  padding: '0.5rem 1rem',
  fontSize: '0.85rem',
  cursor: 'pointer',
};
export const smallBtn: React.CSSProperties = {
  background: '#fff',
  color: 'var(--green)',
  border: '1px solid var(--line)',
  borderRadius: 999,
  padding: '0.25rem 0.5rem',
  fontSize: '0.75rem',
  cursor: 'pointer',
};
